
import {Component, Vue} from "vue-property-decorator";
import "bootstrap/js/dist/modal";

@Component
export default class DownloadGumroad extends Vue {
  private windowsLink = "";
  private macosLink = "";
  private linuxLink = "";
  private zipLink = "";

  public mounted() {
    this.windowsLink = "/checkout#win";
    this.macosLink = "/checkout#mac";
    this.linuxLink = "/checkout#lin";
    this.zipLink = "/checkout#zip";
  }
}
